import './media_boxes.scss';
import Dropdown from 'src/classes/Dropdown';

const dropdown_open_animation = 'fade-in-bottom-short 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both';

class FF_Media_Boxes {

    constructor(container){
        this.container = container;
        this.init();
        // console.log('FF_Media_Boxes', this);
    }

    init(){
        this.settings = JSON.parse(this.container.dataset.mb_settings);

        console.log(this.settings);

        this.isotope_init();
        this.filters_init();
        this.load_more_init();
        this.search_init();
    }

    reveal_items(){
        this.isotope.arrange({ filter: '.mb_item' });
    }

    isotope_init(){
        let items_container = this.container.querySelector('.mb_items');
        this.isotope = new Isotope( items_container, {
            itemSelector: '.mb_item',
            layoutMode: 'fitRows',
            transitionDuration: 550,
            hiddenStyle: {
                opacity: 0,
                transform: 'scale(0.9)',
            },
            visibleStyle: {
                opacity: 1,
                transform: 'scale(1)',
            }
        });
    }
    
    load_more_init(){

        this.have_more_items = true;

        let load_more_con = document.createElement('div');
        this.load_more_con = load_more_con;
        load_more_con.classList.add('mb_load_more_con');
        this.container.after(load_more_con);

        let load_more_button = document.createElement('button');
        this.load_more_button = load_more_button;
        load_more_button.classList.add('button');
        load_more_button.classList.add('mb_load_more_button');
        load_more_button.innerText = 'Load More';
        load_more_con.append(load_more_button);

        load_more_button.addEventListener('click',()=>{
            this.load_more(this.settings.load_more_items);
        });

        this.load_more_enable();
        
        this.load_more(this.settings.initial_items);
    }

    load_more(num_to_show){

        let filtered_items = this.isotope.filteredItems;
        
        let count = 0;

        for( let i = 0; i < filtered_items.length; i++ ) {

            let item = filtered_items[i].element;

            if( item.classList.contains('mb_hidden') ) {
                item.classList.remove('mb_hidden');
                count++;
            }

            if( i+1 == filtered_items.length ) {
                this.have_more_items = false;
            }
            
            if( count == num_to_show ) break;
        }
        
        this.load_more_update();
        
        this.isotope.layout();
    }

    load_more_update(){
        
        if( !this.have_more_items ) {
            // no more items left, disable load more
            this.load_more_disable();
        }
        else {
            this.load_more_enable();
        }
        
    }

    get_have_more_items(){
        let filtered_items = this.isotope.filteredItems;
        for( let i = 0; i < filtered_items.length; i++ ) {
            let item = filtered_items[i].element;
            if( item.classList.contains('mb_hidden') ) {
                return true;
            }
        }
        return false;
    }

    load_more_disable(){
        
        this.load_more_con.style.display = 'none';
        
        if( typeof this.load_more_observer !== 'undefined' ) {
            this.load_more_observer.unobserve(this.load_more_button);
            this.load_more_observer = undefined;
        }
        
    }

    load_more_enable(){

        this.load_more_con.style.display = '';

        this.load_more_observer_init();
    }

    load_more_observer_init(){

        if( !this.settings.auto_load_more ) return;

        let observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.load_more(this.settings.load_more_items);
                }
            });
        });
        
        observer.observe(this.load_more_button);

        this.load_more_observer = observer;
    }
    
    filters_init(){

        this.filters_container = this.settings.filters_container ?? this.container;

        if( typeof this.filters_container === 'string' ) {
            this.filters_container = document.querySelector(this.filters_container);
        }

        this.filters = [];
        this.filter_buttons_init();
        this.filter_dropdowns_init();
        this.filter_keys = Object.keys(this.filters);
    }

    filter_buttons_init(){
        
        this.filters_container.querySelectorAll('.mb_filter_buttons').forEach(filter_buttons_con=>{

            let filter_key = filter_buttons_con.dataset.filter_key;

            let multiple = typeof filter_buttons_con.dataset.filter_multiple !== 'undefined';
            let single_selected = null;
            let multiple_selected = [];

            this.filters[filter_key] = multiple ? [] : '';
            
            filter_buttons_con.querySelectorAll('button').forEach(button=>{

                let filter_value = button.dataset.filter;

                button.addEventListener('click',()=>{
                    
                    let is_selected = button.classList.contains('selected');

                    if( multiple ) {
                        
                        // multiple - add / remove

                        if( is_selected ) {
                            // unselect
                            button.classList.remove('selected');
                            multiple_selected.splice(multiple_selected.indexOf(button), 1);
                            this.filters[filter_key].splice(this.filters[filter_key].indexOf(filter_value), 1);
                        }
                        else {
                            button.classList.add('selected');
                            multiple_selected.push(button);
                            this.filters[filter_key].push(filter_value);
                        }
                    }
                    else {
                        
                        // single - direct replace
                        
                        if( single_selected ) {
                            // unselect previous
                            single_selected.classList.remove('selected');
                        }

                        single_selected = button;
                        single_selected.classList.add('selected');
                        this.filters[filter_key] = filter_value;
                    }

                    this.filter_items();
                });
            })
        });
    }

    filter_dropdowns_init(){

        this.filters_container.querySelectorAll('.mb_filter_dropdown').forEach(container=>{
            let dropdown = container.querySelector('select');
            if( !dropdown ) return;
            let filter_key = container.dataset.filter_key;
            let multiple = typeof container.dataset.filter_multiple !== 'undefined';
            this.filters[filter_key] = multiple ? [] : '';
            dropdown.addEventListener('change',()=>{
                this.filters[filter_key] = dropdown.value;
                this.filter_items();
            });

            new Dropdown(dropdown, {
                animation_open: dropdown_open_animation,
            });
        })
    }
    
    show_minimum_items(){

        let filtered_items = this.isotope.filteredItems;

        if( !filtered_items.length ) {
            this.no_results_show();
            return;
        }
        
        this.no_results_hide();

        // show minimum initial items
        let new_items_to_show = 0;

        for( let i = 0; i < this.settings.initial_items; i++ ) {

            let item = filtered_items[i].element;

            if( item.classList.contains('mb_hidden') ) {
                item.classList.remove('mb_hidden');
                new_items_to_show++;
            }

            if( i+1 == filtered_items.length ) break;
           
        }

        if( filtered_items.length <= this.settings.initial_items ) {
            this.have_more_items = false;
        }
        
        if( new_items_to_show ) {
            this.isotope.layout();
        }

        this.have_more_items = this.get_have_more_items();

        // console.log('show_minimum_items', { new_items_to_show, filtered_items, have_more_items: this.have_more_items })

        this.load_more_update();
    }

    filter_items(){

        let filter = '';
        let exclusives = '';
        let inclusives = [];

        for( let i = 0; i < this.filter_keys.length; i++ ) {

            let filter_key = this.filter_keys[i];
            let filter_value = this.filters[filter_key];
            if( !filter_value || !filter_value.length ) continue;
            
            if( typeof filter_value == 'object' ) {
                
                // inclusive / multiple
                filter_value.forEach(value=>{
                    // exact
                    // inclusives.push('[data-'+ filter_key +'="'+ value +'"]');

                    // wildcard
                    inclusives.push('[data-'+ filter_key +'*="'+ value +'"]');
                })
            }
            else {
                // exclusive / single

                // exact
                // exclusives += '[data-'+ filter_key +'="'+ filter_value +'"]';
                
                // wildcard
                exclusives += '[data-'+ filter_key +'*="'+ filter_value +'"]';
            }
        }
        
        if( inclusives.length ) {
            filter = inclusives.map(inclusive=>{
                return exclusives + inclusive;
            }).join(',');
        }
        else {
            filter = exclusives;
        }

        // console.log(this.filters)
        // console.log({exclusives, inclusives})
        // console.log('filter_items', {filter})
        
        // apply filters
        this.isotope.arrange({ filter });

        // console.log(this.isotope.filteredItems)

        this.show_minimum_items();
    }

    no_results_show(){

        if( typeof this.no_results_el === 'undefined' ) {
            this.no_results_el = document.createElement('div');
            this.no_results_el.innerHTML = 'No results found, try different filters.';
            this.no_results_el.classList.add('mb_no_results');
            this.container.append(this.no_results_el);

            this.no_results_el.style.display = 'none';
        }

        this.no_results_el.style.display = '';
        
        this.have_more_items = false;
        this.load_more_update();
    }

    no_results_hide(){
        if( typeof this.no_results_el === 'undefined' || this.no_results_el.style.display == 'none' ) return;
        this.no_results_el.style.display = 'none';
    }

    search_init(){

        let search_input = this.filters_container.querySelector('.mb_search input');
        this.search_input = search_input;
        if( !search_input ) return;

        this.last_search = '';

        let timer = null;
        search_input.addEventListener('keydown',e=>{
            clearTimeout(timer);
            if( e.key == 'Enter' ) {
                this.search_submit();
                return;
            }
            timer = setTimeout(()=>this.search_submit(), 500);
        }); 
    }

    search_submit(){
        let search_value = this.search_input.value;
        if( search_value == this.last_search ) return; // no change
        this.last_search = search_value;

        let search_regex = new RegExp( search_value, 'gi' );

        this.isotope.arrange({ filter: function(){
            return search_regex ? this.textContent.match( search_regex ) : true;
        }})
        
        if( !this.isotope.filteredItems.length ) {
            this.no_results_show();
        } else {
            this.no_results_hide();
        }
    }
    
}

document.querySelectorAll('.ff_media_boxes').forEach(container=>{
    new FF_Media_Boxes(container);
})